<template>
  <transition name="modal">
    <div
      class="fixed inset-0 z-[1000] flex items-center justify-center overflow-auto bg-black/40 p-4"
      @click.self="$emit('close')"
    >
      <div class="flex w-full items-center justify-center" @click.self="$emit('close')">
        <div
          class="modal-container flex w-full flex-col overflow-hidden bg-[#1e1e1e] text-[14px] text-[#e1e1e1]"
          :class="[
            wide ? 'max-w-[1040px]' : 'max-w-[768px]',
            fit ? 'modal-container--fit' : '',
          ]"
        >
          <div v-if="$slots.header || headerText" class="modal-header">
            <slot name="header">
              <div class="modal-header__title">{{ headerText }}</div>
              <button
                v-if="headerText"
                type="button"
                class="tb-btn tb-btn-text sm low-em modal-close-btn"
                data-entity="producer-closeModal"
                @click="$emit('close')"
              >
                <span class="fas fa-times" />
              </button>
            </slot>
          </div>

          <div
            class="min-h-0 flex-1 overflow-y-auto px-5 py-4"
            :style="bodyStyle"
          >
            <slot />
          </div>

          <div v-if="$slots.footer" class="flex items-center justify-end gap-3 border-t border-white/10 px-5 py-4">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    headerText: {
      type: String,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    fit: {
      type: Boolean,
      default: false,
    },
    bodyStyle: {
      type: [String, Object],
      default: '',
    },
  },
  mounted() {
    this.handleKeydown = (e) => {
      if (e.key === 'Escape') {
        this.$emit('close');
      }
    };

    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
};
</script>

<style scoped>
.modal-container {
  position: relative;
  width: 100%;
  height: auto;
  margin: 3.125rem auto;
  border-radius: 2px;
  box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, .5);
  background-color: #1e1e1e;
  overflow: hidden;
}

.modal-container--fit {
  min-height: 12.5rem;
  max-height: calc(100vh - 6.25rem);
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border: 0;
  background-color: #252525;
}

.modal-header__title {
  flex: 1;
  font-size: 16px;
  font-weight: 500;
}

.modal-close-btn {
  color: #7b7b7b;
  padding: 0.25rem 0.375rem;
  border: 0;
  border-radius: 2px;
  outline: 0;
  box-shadow: none;
  background: none;
  white-space: nowrap;
  transition: width 200ms ease, background-color .25s ease-in-out, color .25s ease-in-out, border .25s ease-in-out;
}

.modal-close-btn:hover {
  color: #e1e1e1;
}
</style>
